import { Component, Input } from '@angular/core'
import { FormErrors } from '@ui/HttpError'
import { MatError } from '@angular/material/input'
import { NgStyle } from '@angular/common'

@Component({
	selector: 'form-error',
	template: ` <mat-error [ngStyle]="styles">{{ error }}</mat-error> `,
	imports: [MatError, NgStyle],
})
export class FormErrorComponent {
	@Input() public error: string | FormErrors

	@Input() public styles: { [style: string]: string | number }
}
